import { observer } from "mobx-react";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Dimensions, Image, RefreshControl, SafeAreaView, ScrollView, StyleSheet, Text, View } from "react-native";
import { Button } from "react-native-elements";
import { RFValue } from "react-native-responsive-fontsize";
import { Row, Table } from "react-native-table-component";
import enableUser from "../../networking/api/user/enableUser";
import state from "../../store/Store";
import enableUserAction from "../alert/enableUserAction";

const { height, width } = Dimensions.get("window");

const Users = observer(({ data, loading, setRefresh }) => {
  const { uid, accessToken } = state;
  const [items, setItems] = useState([]);
  const [refresher, setRefresher] = useState(false);
  const [isEmpty, setEmpty] = useState(false);
  useEffect(() => {
    setItems(data);
    setTimeout(() => {
      if (data.length === 0) setEmpty(true);
    }, 500);
  }, [data, data.map((o) => o?.documents)]);

  const tableHead = [
    "#",
    "Image",
    "Full Name",
    "Email Address",
    "Suspension Date",
    "Suspension Lift Date",
    "Strike Count",
    "Enable Account",
  ];

  const tableData = items?.map((record, index) => {
    let number = index + 1;
    const { image, name, updatedAt, reactivesAt, count, email, uid } = record || {};
    let suspensionLiftDate = moment.unix(reactivesAt).format("MM/DD/YYYY");
    let suspensionDate = moment.unix(updatedAt).format("MM/DD/YYYY");
    let source = image ? { uri: image } : require("../../assets/user.png");
    return [
      number,
      <Image source={source} style={styles.image} />,
      name,
      email,
      suspensionDate,
      suspensionLiftDate,
      count,
      <Button
        title="Enable"
        buttonStyle={styles.buttonStyle}
        titleStyle={styles.buttonTitle}
        onPress={() => enableUserAction(name, async () => await enableUser(accessToken, uid, (e) => setRefresh(e)))}
      />,
    ];
  });

  const _onRefresh = () => {
    setRefresher(true);
    setRefresh(moment().unix());
    setTimeout(() => setRefresher(false), 2500);
  };

  let flexArr = tableHead.map((o, i) => (i === 0 ? 0.25 : 1));

  return (
    <Table>
      <Row data={tableHead} style={styles.head} textStyle={styles.headerText} flexArr={flexArr} />
      <ScrollView
        contentContainerStyle={styles.scrollView}
        refreshControl={<RefreshControl refreshing={refresher} onRefresh={_onRefresh} />}>
        <SafeAreaView style={styles.view}>
          {isEmpty ? (
            <Text style={styles.notFound}>No records found</Text>
          ) : (
            <Table>
              {tableData?.map((rowData, index) => (
                <View key={rowData + index.toString()}>
                  <Row data={rowData} style={styles.row} textStyle={styles.text} flexArr={flexArr} />
                  <View style={styles.borderLine} />
                </View>
              ))}
            </Table>
          )}
        </SafeAreaView>
      </ScrollView>
    </Table>
  );
});

export default Users;

const styles = StyleSheet.create({
  headerAltText: { fontFamily: "avenir", fontSize: RFValue(9) },
  headerRow: { alignItems: "center", flexDirection: "row", margin: 6 },
  notFound: {
    fontFamily: "avenir-h",
    fontSize: RFValue(22),
    textAlign: "center",
    color: "gray",
  },
  rowView: {
    flexDirection: "row",
    alignItems: "center",
  },
  buttonTitle: { fontSize: RFValue(9), fontFamily: "avenir" },
  buttonStyle: {
    marginRight: 10,
    marginBottom: 2.5,
    paddingVertical: 5,
    borderRadius: 10,
    backgroundColor: "#2E3339",
  },
  borderLine: { borderBottomWidth: 0.5 },
  view: { marginBottom: height * 0.025 },
  tableStyle: { borderColor: "transparent" },
  scrollView: { flexGrow: 0, minHeight: height },
  imageStyle: {
    width: 35,
    height: 35,
    borderRadius: 35 / 2,
  },
  container: {
    flex: 1,
    padding: 16,
    marginBottom: 36,
    backgroundColor: "#fff",
  },
  head: { backgroundColor: "#ECECF4", flexGrow: 0 },
  text: { margin: 6, fontSize: RFValue(9), fontFamily: "avenir" },
  headerText: {
    margin: 6,
    fontSize: RFValue(9),
    fontFamily: "avenir",
  },
  row: { flexDirection: "row", backgroundColor: "white", marginTop: 10 },
  image: {
    width: 50,
    height: 50,
    borderRadius: 25,
    borderWidth: 1,
    borderColor: "#d3d3d3",
  },
  textStyle: { fontFamily: "avenir", fontSize: RFValue(10) },
});
